import { combineReducers } from 'redux';

import projects from './projects';
import project from './single';
import auth from './auth';

export default combineReducers({ projects, project, auth })